import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios
import Header from "../components/Header";

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    company: "",
    industry: "",
    terms: false,
  });

  const [loading, setLoading] = useState(false); // Track API call
  const [error, setError] = useState(""); // Store API error messages

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.terms) {
      alert("Please agree to the Terms & Conditions.");
      return;
    }

    setLoading(true); // Start loading
    setError(""); // Reset error state

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/signup`,
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Signup Successful:", response.data);

      // ✅ Redirect with message
      navigate("/login", {
        state: { successMessage: "Signup successful! Please login." },
      });
    } catch (error) {
      console.error("Signup Error:", error);
      setError(error.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Stop loading
    }
  };



  

  return (
    <>
      <Header />
      <div id="wrapper">
        <section className="signup-section d-flex align-items-center py-5 py-md-0">
          <div className="container signup-container">
            <div className="row">
              <div className="col-md-6 text-white d-flex align-items-center pe-md-5">
                <div className="pe-md-5 text-center text-md-start">
                  <h1 className="fw-bold mb-4">Discover have an account?</h1>
                  <p className="color858c95 ft-18 lh-27 inter">
                    Register to access all the features of our services. Manage
                    your business in one place. It's Free!
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-container mt-5 mt-md-0">
                  <h2 className="fw-bold mb-4">Sign Up</h2>

                  {error && <p className="text-danger">{error}</p>}{" "}
                  {/* Show error message */}
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder=" "
                        autoComplete="new-name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder=" "
                        autoComplete="new-email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder=" "
                        autoComplete="new-password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="password">Password</label>
                    </div>
                    <div className="form-check my-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="terms"
                        name="terms"
                        checked={formData.terms}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label ft-14 lh-24 fw-500"
                        htmlFor="terms"
                      >
                        Agree to Terms & Conditions
                      </label>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-red ft-15 fw-600 w-100 my-3 py-3"
                      disabled={loading}
                    >
                      {loading ? "Signing Up..." : "Sign Up"}{" "}
                      <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>
                    <p className="mt-3 ft-14 lh-24">
                      Already have an account?{" "}
                      <span
                        className="login-link"
                        onClick={() => navigate("/login")}
                        style={{ cursor: "pointer", color: "red" }}
                      >
                        Login
                      </span>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Signup;